import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { BlogCategoryCreate, BlogCategoryEntity, BlogCategoryUpdate } from '@repo/types';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlogCategoryApiService extends BaseApi<BlogCategoryEntity, BlogCategoryCreate, BlogCategoryUpdate> {
  constructor() {
    super('blogCategories', {
      get: '/AdminPanel/GetBlogCategories',
      post: '/AdminPanel/AddBlogCategory',
    });
  }
  getAllBlogCategories<T = BlogCategoryEntity>() {
    let queryParams = `?Pagination.Page=1&Pagination.AmountOfListPerPage=999999&filters.type=0`;
    return http$
      .get<{ dataWithPagination: { data: T[] } }>(`${this.endpoint.get}${queryParams}`)
      .pipe(map((i) => i.dataWithPagination.data));
  }

  updateBlogCategory(model: BlogCategoryUpdate) {
    console.log(model);
    return http$.patch<never>('/AdminPanel/EditBlogCategory', model);
  }

  deleteBlogCategory(id: number) {
    return http$.delete<never>('/AdminPanel/DeleteBlogCategory', { body: { id: id } });
  }
}
